@if (loading() || loadingError()) {
  <app-splash-screen [error]="loadingError()"></app-splash-screen>
}

<ng-container [class.remove]="loading() || loadingError()">
  @if (environmentInstanceName() !== "PROD") {
    <span class="test">{{ environmentInstanceName() }}</span>
  }

  <!-- <app-banner-maintenance [maintenance]="true"></app-banner-maintenance> -->

  @if (isAuth() && isDesktop() && showAppHeader(outlet)) {
    <app-desktop-header class="main-header"></app-desktop-header>
  }

  <div class="scrollable" [class.desktop]="isDesktop()" id="scrollContent">
    <!-- <app-header [transparent]="headerTransparent(outlet)"></app-header> -->
    <div id="main" [@routeAnimations]="prepareRoute(outlet)">
      <router-outlet
        #outlet="outlet"
        (activate)="onActivate(outlet)"
      ></router-outlet>
    </div>
  </div>

  @if (isAuth() && !isDesktop()) {
    <app-footer>
      <app-tab-menu></app-tab-menu>
    </app-footer>
  }
</ng-container>

<div class="modal-content">
  <nz-modal
    nzClassName="offline-status-modal"
    [nzVisible]="modalOpen()"
    [nzFooter]="null"
    [nzCentered]="true"
    [nzTitle]="Internet()"
    (nzOnCancel)="cancelClick()"
  >
    <div class="network-modal-body">
      <div class="network-modal-icon set-margin-auto">
        <i
          style="font-size: 40px"
          nz-icon
          nzType="icons:status-exclamation-triangle"
        ></i>
      </div>
      <div class="set-margin-auto">
        <h3 class="network-modal-heading">
          {{ i18n.langString("network_issue_msg") }}
        </h3>
      </div>
      <div class="network-modal-content set-margin-auto">
        {{ i18n.langString("network_issue_content") }}
      </div>
      <div class="network-modal-button asset-nav-button-content">
        <i nz-icon nzType="icons:refresh" class="svg-icon fillwhite"></i>
        <span
          class="reconnect"
          tabindex="0"
          role="button"
          (click)="tryReconnect()"
          (keydown.enter)="tryReconnect()"
          (keydown.space)="tryReconnect()"
        >
          {{ i18n.langString("network_issue_reconnect") }}
        </span>
      </div>
    </div>
  </nz-modal>
</div>
